import MinhaConta from '../pages/Inicio/MinhaConta/Menu'
import Equipamentos from '../pages/Sistema/Equipamentos/Menu'
import Condicoes from '../pages/Admin/Condicoes/Menu'
import Empresas from '../pages/Admin/Empresas/Menu'
import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Menu'
import Situacoes from '../pages/Admin/Situacoes/Menu'
import Status from '../pages/Admin/Status/Menu'
import Usuarios from '../pages/Admin/Usuarios/Menu'
import Voltagem from '../pages/Admin/Voltagem/Menu'

const MenuDefault = [{
	titulo: 'Início',
	icone: 'menu-icon fa fa-tachometer',
	action: false,
	visualizar: false,
	submenu: [...MinhaConta]
},
{
	titulo: 'Sistema',
	icone: 'menu-icon fa fa-desktop',
	action: false,
	visualizar: false,
	submenu: [...Equipamentos]
},
{
	titulo: 'Admin',
	icone: 'menu-icon fa fa-cog',
	action: false,
	visualizar: false,
	submenu: [...Condicoes, ...Empresas, ...GrupoDeAcesso, ...Situacoes, ...Status, ...Usuarios, ...Voltagem]
}]

export default MenuDefault
